import React, { useEffect, useState } from "react";
import { usePackagesActions, usePackagesState } from "@/store";
import { subscribeUploadCompletion } from "@/Service/uploadCompletionEvents";
import PackageSection from "./PackageSection";
import { DashboardContainer } from "../Stats/Counter/CountersBlock.elements";
import { PackageWrapper, PackageLoaderWrap, PackageCloseWrap } from "./Package.elements";
import { AbsCrossButton } from "@/components";
import { CircularProgress, Stack } from "@mui/material";
import NoDataState from "@/components/EmptyData/NoDataState";

const DashboardPackageGroupSelection = ({ contributorId, onClose }) => {
    const state = usePackagesState();
    const packages = state?.packages || [];
    const status = state?.fetch?.status || state?.status;

    const { fetchPackages } = usePackagesActions();

    const currentPage = 0;
    const pageSize = 3;
    // See PackageGroupSection: bumped when an upload finishes so the fetch effect re-runs
    // and the user sees their just-finished upload without needing to navigate away.
    const [refreshTick, setRefreshTick] = useState(0);

    useEffect(() => {
        fetchPackages({ contributors: contributorId, currentPage, pageSize });
    }, [contributorId, fetchPackages, refreshTick]);

    useEffect(() => subscribeUploadCompletion(() => setRefreshTick((t) => t + 1)), []);

    const isLoading = status === "loading";
    const hasData = packages.length > 0;

    return (
        <DashboardContainer>
            <PackageWrapper>
                {!!onClose && (
                    <PackageCloseWrap>
                        <AbsCrossButton onClick={onClose} />
                    </PackageCloseWrap>
                )}

                {isLoading ? (
                    <PackageLoaderWrap>
                        <Stack alignItems="center">
                            <CircularProgress size="60px" disableShrink color="white" />
                        </Stack>
                    </PackageLoaderWrap>
                ) : !hasData ? (
                    <PackageLoaderWrap>
                        <Stack alignItems="center">
                            <NoDataState />
                        </Stack>
                    </PackageLoaderWrap>
                ) : (
                    packages.map((pkg) => (
                        <PackageSection
                            key={pkg.id || pkg.packageId || pkg.uploadId || `${pkg.packageName}-${pkg.createdAt}`}
                            uploadMetadataId={pkg.id}
                            packageName={pkg.packageName}
                            description={pkg.description}
                            contributorName={pkg.contributorName}
                            dateShot={new Date(pkg.createdAt * 1000).toLocaleDateString("en-GB", {
                                weekday: "short",
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                            })}
                            status={pkg.status}
                            upload={pkg}
                            feedback={pkg.feedback}
                        />
                    ))
                )}
            </PackageWrapper>
        </DashboardContainer>
    );
};

export default DashboardPackageGroupSelection;
